var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCtaCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1290,
    height: 645,
    viewBox: "0 0 1290 645",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1290 645C1290 560.297 1273.32 476.424 1240.9 398.169C1208.49 319.914 1160.98 248.81 1101.08 188.916C1041.19 129.022 970.086 81.512 891.831 49.0977C813.576 16.6834 729.703 -3.70247e-06 645 0C560.297 3.70247e-06 476.424 16.6834 398.169 49.0977C319.914 81.512 248.81 129.022 188.916 188.916C129.022 248.81 81.512 319.914 49.0977 398.169C16.6834 476.424 -7.40494e-06 560.297 0 645L645 645H1290Z",
    fill: "url(#paint0_linear_460_32943)",
    fillOpacity: 0.05
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_460_32943",
    x1: 645,
    y1: 0,
    x2: 645,
    y2: 485.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007AFF",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCtaCircle);
export default __webpack_public_path__ + "static/media/cta-circle.51bbab7a2ea19287f7a5a78509632caf.svg";
export { ForwardRef as ReactComponent };